<template>
  <CModal :title="title" :color="color" :show.sync="showModal" class="event-modal basic-modal-color">
    <CForm id="document_form" method="POST" enctype="multipart/form-data">
      <CInput hidden :lazy="false" :value.sync="$v.form.id.$model" name="id" id="id" />
      <ul class="nav nav-tabs justify-content-begin">
        <li @click="changeTab('event')" class="nav-item">
          <a class="nav-link" :class="tab == 'event' ? 'active' : ''" aria-current="page">Evento</a>
        </li>
        <li @click="changeTab('documents')" class="nav-item">
          <a class="nav-link" :class="tab == 'documents' ? 'active' : ''">Invitación </a>
        </li>
        <li @click="changeTab('planner')" class="nav-item">
          <a class="nav-link" :class="tab == 'planner' ? 'active' : ''">Organización </a>
        </li>
        <li @click="changeTab('messaging')" class="nav-item">
          <a class="nav-link" :class="tab == 'messaging' ? 'active' : ''">Mensajería </a>
        </li>
      </ul>
      <br>
      <div v-show="tab == 'event'">
        <CRow>
          <CCol md="4">
            <CInput label="Código:" :lazy="false" :value.sync="$v.form.code.$model" name="code" id="code" placeholder=""
              autocomplete="given-code" />
          </CCol>
          <CCol md="8">
            <CInput label="Nombre:" :lazy="false" :value.sync="$v.form.name.$model" :isValid="checkIfValid('name')"
              name="name" id="name" placeholder="Nombre del evento" autocomplete="given-name"
              invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4">
            <div role="group" class="form-group">
              <label> Fecha del Evento:</label>
              <v-date-picker class="date-picker" v-model="$v.form.date.$model" :isValid="checkIfValid('date')"
                locale="es-MX" size="sm" :popover="{ visibility: 'click' }" />
              <input type="hidden" name="date" id="date" v-model="$v.form.date.$model">
            </div>
          </CCol>
          <CCol md="4">
            <div role="group" class="form-group">
              <label> Hora Inicio:</label>
              <vue-timepicker hide-clear-button v-model="$v.form.start_hour.$model" hour-label="H" minute-label="M"
                auto-scroll close-on-complete placeholder="00:00" format="HH:mm" id="start_hour" name="start_hour"
                minute-interval=15 input-class="hour-time-picker">
              </vue-timepicker>
            </div>
          </CCol>
          <CCol md="4">
            <div role="group" class="form-group">
              <label> Hora Final: </label>
              <vue-timepicker hide-clear-button v-model="$v.form.end_hour.$model" hour-label="H" minute-label="M"
                auto-scroll close-on-complete format="HH:mm" placeholder="00:00" id="end_hour" name="end_hour"
                minute-interval=15 input-class="hour-time-picker">
              </vue-timepicker>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4">
            <CInput label="N° Invitados:" :lazy="false" :value.sync="$v.form.tickets.$model"
              :isValid="checkIfValid('tickets')" name="tickets" id="tickets" placeholder="" autocomplete="given-tickets"
              invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
          </CCol>
          <CCol md="4">
            <CInput label="Prefijo Mesas:" :lazy="false" :value.sync="$v.form.pre_tables.$model" name="pre_tables"
              id="pre_tables" placeholder="Mesa-" />
          </CCol>
          <CCol md="4">
            <CInput label="N° Mesas:" :lazy="false" :value.sync="$v.form.num_tables.$model"
              :isValid="checkIfValid('num_tables')" name="num_tables" id="num_tables" placeholder=""
              autocomplete="given-num_tables"
              invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
          </CCol>
        </CRow>
        <CRow class="mt-3 mb-3">
          <CCol md="12">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="external_registration_enabled" name="external_registration_enabled"
                v-model="$v.form.external_registration_enabled.$model" />
              <label class="form-check-label" for="external_registration_enabled">
                Habilitar registro externo vía enlace público
              </label>
            </div>
          </CCol>
        </CRow>
        <CRow v-if="$v.form.external_registration_enabled.$model">
          <CCol md="6">
            <CSelect :value.sync="$v.form.contact_method.$model" label="Medio de contacto" :options="[
              { label: 'Telefono', value: 'phone' },
              { label: 'Correo electrónico', value: 'email' }
            ]" :isValid="checkIfValid('contact_method')" placeholder="Selecciona una opción" name="contact_method"
              id="contact_method" invalidFeedback="Este campo es obligatorio" />
          </CCol>

          <CCol md="6">
            <CInput label="Máx. boletos por invitado" :value.sync="$v.form.max_companions.$model"
              :isValid="checkIfValid('max_companions')" name="max_companions" id="max_companions"
              placeholder="Ej. 2" invalidFeedback="Este campo es obligatorio" />
          </CCol>
        </CRow>

      </div>
      <div v-show="tab === 'documents'">
        <CRow>
          <CCol md="12">
            <CInput label="Salón/Dirección:" :lazy="false" :value.sync="$v.form.address.$model" name="address"
              id="address" placeholder="salon, dirección del evento" autocomplete="given-address" />
          </CCol>
          <CCol md="12">
            <CInput label="Descripción:" :lazy="false" :value.sync="$v.form.description.$model" name="description"
              id="description" placeholder="descripcion del evento" autocomplete="given-description" />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12">
            <CInput label="Imagen/Pdf/Invitación:" :lazy="false" :value.sync="$v.form.document.$model" type="file"
              name="document" id="document" placeholder="" accept=".jpg, .jpeg, .png, .pdf"
              autocomplete="given-document" />
          </CCol>
        </CRow>
        <CRow v-if="form.image">
          <CCol md="12">
            <img v-if="!isPdf(form.image)" :src="form.image" class="img-fluid" alt="Imagen del evento" />
            <span v-else><a :href="form.image" target="_blank">Ver PDF</a></span>
          </CCol>
        </CRow>
      </div>
      <div v-show="tab == 'planner'">
        <CRow>
          <CCol md="6">
            <CSelect label="Clase:" :value.sync="$v.form.event_class_id.$model"
              :isValid="checkIfValid('event_class_id')" :options="classesOptions" name="event_class_id"
              id="event_class_id" invalidFeedback="Este campo es requerido." />
          </CCol>
          <CCol md="6">
            <CSelect label="Estado:" :value.sync="$v.form.event_status_id.$model"
              :isValid="checkIfValid('event_status_id')" :options="statusOptions" name="event_status_id"
              id="event_status_id" invalidFeedback="Este campo es requerido." />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="8">
            <CInput label="Organizador:" :lazy="false" :value.sync="$v.form.planner_name.$model" name="planner_name"
              id="planner_name" placeholder="Organizador del evento" autocomplete="given-planner_name" />
          </CCol>
          <CCol md="4">
            <CInput label="Telefono Org.:" :lazy="false" :value.sync="$v.form.planner_phone.$model" name="planner_phone"
              id="planner_phone" autocomplete="given-planner_phone" />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12">
            <CInput label="Correo Org.:" :lazy="false" :value.sync="$v.form.planner_email.$model" name="planner_email"
              id="planner_email" placeholder="organizador@correo.com" autocomplete="given-email" />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12">
            <CInput label="Comentarios:" :lazy="false" :value.sync="$v.form.comments.$model" name="comments"
              id="comments" placeholder="Comentarios del evento" autocomplete="given-comments" />
          </CCol>
        </CRow>
      </div>
      <div v-show="tab == 'messaging'">
        <CRow>
          <CCol md="6">
            <div role="group" class="form-group">
              <label>Inicio de Confirmaciones:</label>
              <v-date-picker class="date-picker" v-model="$v.form.initial_confirm_date.$model" locale="es-MX"
                size="sm" :popover="{ visibility: 'click' }" />
              <input type="hidden" name="initial_confirm_date" id="initial_confirm_date"
                v-model="$v.form.initial_confirm_date.$model">
            </div>
          </CCol>
          <CCol md="6">
            <div role="group" class="form-group">
              <label> Fin de Confirmaciones:</label>
              <v-date-picker class="date-picker" v-model="$v.form.last_confirm_date.$model" locale="es-MX" size="sm" :popover="{ visibility: 'click' }" />
              <input type="hidden" name="last_confirm_date" id="last_confirm_date"
                v-model="$v.form.last_confirm_date.$model">
            </div>
          </CCol>
        </CRow>
        <CRow class="mt-3 mb-3">
          <CCol md="12">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="restrictions_enabled" name="restrictions_enabled"
                v-model="$v.form.restrictions_enabled.$model" />
              <label class="form-check-label" for="restrictions_enabled">
                Solicitar a los invitados si tienen restricciones alimenticias.
              </label>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12">
            <CSelect :value.sync="$v.form.guest_addressing_mode.$model" label="Forma de dirigirse al invitado"
              :options="[
                { label: 'Nombre', value: 'name' },
                { label: 'Nombre y apellido', value: 'name_last_name' },
                { label: 'Apodo', value: 'nickname' }
              ]" name="guest_addressing_mode" id="guest_addressing_mode"
              placeholder="Selecciona una opción" />
          </CCol>
        </CRow>
      </div>
    </CForm>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="store" :color="color">Aceptar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, minValue, helpers } from "vuelidate/lib/validators"
import ws_class from '../../services/events_classes';
import ws_status from '../../services/events_status';
import ws_code from '../../services/events_codes';
import ws_planner from '../../services/events_planners';
import { DatePicker } from 'v-calendar';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

import moment from 'moment';
import moment_timezone from 'moment-timezone'

moment.tz.setDefault('America/Mexico_city')

export default {
  name: 'EventModal',
  props: {
  },
  components: {
    'v-date-picker': DatePicker,
    VueTimepicker
  },
  data() {
    return {
      showModal: false,
      title: "Nuevo Evento",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      classesOptions: [],
      statusOptions: [],
      tab: 'event',
    }
  },
  mounted: async function () {
    let response_class = await ws_class.get();
    if (response_class.type == "success") {
      this.classesOptions = await this.$parseSelectOptionsOrdered(response_class.data, "id", "name", []);
    }
    let response_status = await ws_status.get();
    if (response_status.type == "success") {
      this.statusOptions = await this.$parseSelectOptionsOrdered(response_status.data, "id", "name", []);
    }
  },
  methods: {
    changeTab(tab) {
      if (this.tab != tab) {
        this.tab = tab;
      }
    },
    isPdf(file_url) {
      return file_url.endsWith(".pdf");
    },
    async storeModal() {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Evento';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
        id: 0,
        name: '',
        description: '',
        comments: '',
        address: '',
        code: "",
        image: "",
        document: "",
        date: moment().toDate(),
        initial_confirm_date: moment().toDate(),
        last_confirm_date: moment().toDate(),
        start_hour: "",
        end_hour: "",
        tickets: 0,
        pre_tables: "",
        planner_name: "",
        planner_phone: "",
        num_tables: 0,
        event_class_id: this.classesOptions[0].value,
        event_status_id: this.statusOptions[0].value,
        planner_email: "",
        external_registration_enabled: false,
        restrictions_enabled: true,
        contact_method: '', // 'phone' o 'email'
        max_companions: 0,
        guest_addressing_mode: 'name'
      }
      let response_code = await ws_code.getDefault();
      if (response_code.type == "success") {
        this.form.code = response_code.data;
      }

      let response_planner = await ws_planner.getDefault();
      if (response_planner.type == "success") {
        this.form.planner_name = response_planner.data.name;
        this.form.planner_phone = response_planner.data.phone;
        this.form.planner_email = response_planner.data.email ? response_planner.data.email : "";
      }
    },
    updateModal(item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Evento';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
        id: item.id,
        name: item.name,
        description: item.description,
        comments: item.comments,
        address: item.address,
        code: item.code,
        image: item.image,
        document: "",
        date: moment(item.date, "YYYY-MM-DD").toDate(),
        initial_confirm_date: moment(item.initial_confirm_date, "YYYY-MM-DD").toDate(),
        last_confirm_date: moment(item.last_confirm_date, "YYYY-MM-DD").toDate(),
        start_hour: item.start_hour,
        end_hour: item.end_hour,
        tickets: item.tickets,
        pre_tables: item.pre_tables,
        num_tables: item.num_tables,
        planner_name: item.planner_name,
        planner_email: item.planner_email ? item.planner_email : "",
        planner_phone: item.planner_phone,
        event_class_id: item.event_class_id,
        event_status_id: item.event_status_id,
        external_registration_enabled: item.external_registration_enabled,
        restrictions_enabled: item.restrictions_enabled,
        contact_method: item.contact_method, // 'phone' o 'email'
        max_companions: item.max_companions,
        guest_addressing_mode: item.guest_addressing_mode ? item.guest_addressing_mode : 'name'
      };
    },
    store() {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        let form = document.getElementById("document_form");
        let formData = new FormData(form);

        formData.set("date", moment(formData.get("date")).format("YYYY-MM-DD"));
        formData.set("initial_confirm_date", moment(formData.get("initial_confirm_date")).format("YYYY-MM-DD"));
        formData.set("last_confirm_date", moment(formData.get("last_confirm_date")).format("YYYY-MM-DD"));
        formData.set("external_registration_enabled", this.form.external_registration_enabled ? 1 : 0);
        formData.set("restrictions_enabled", this.form.restrictions_enabled ? 1 : 0);
        if (this.form.id > 0) {
          this.$emit("update", formData);
        }
        else {
          this.$emit("store", formData);
        }

        this.closeModal();
      }
    },
    closeModal() {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm() {
      return {
        id: 0,
        name: '',
        description: '',
        comments: '',
        address: '',
        code: "",
        date: "",
        start_hour: "",
        end_hour: "",
        tickets: "",
        pre_tables: "",
        num_tables: "",
        planner_name: "",
        planner_email: "",
        planner_phone: "",
        event_class_id: "",
        event_status_id: "",
        document: "",
        external_registration_enabled: false,
        restrictions_enabled: true,
        contact_method: '', // 'phone' o 'email'
        max_companions: 0,
        guest_addressing_mode: 'name'

      }
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }

      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$invalid },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {
      },
      name: {
        required,
        minLength: minLength(3)
      },
      date: {
        required,
      },
      last_confirm_date: {
      },
      initial_confirm_date: {
      },
      start_hour: {
      },
      end_hour: {
      },
      tickets: {
        required,
      },
      planner_name: {
      },
      planner_email: {
      },
      planner_phone: {
      },
      pre_tables: {
      },
      num_tables: {
      },
      comments: {
      },
      description: {
      },
      address: {
      },
      code: {
      },
      document: {
      },
      event_class_id: {
        required,
        minValue: minValue(1)
      },
      event_status_id: {
        required,
        minValue: minValue(1)
      },
      external_registration_enabled: false,
      restrictions_enabled: true,
      contact_method: '', // 'phone' o 'email'
      max_companions: 0,
      guest_addressing_mode: ''
    }
  },
}
</script>
<style>
.hour-time-picker {
  border-radius: 4px;
  height: 36px !important;
  width: 6em !important;
}

.event-modal .modal-body {
  padding-top: 0px !important;
}

.basic-modal-color .modal-header {
  background-color: #668269 !important;
}
</style>